import {SearchBox} from "@mapbox/search-js-react";
import React, { useRef, useEffect, useState, useCallback } from 'react';
import './SearchBar.css'
import SideBar from './SideBar.js'
import OutsideDomain from './OutsideDomain'
import instance from "./AxiosInstance"


export default function SearchBar(
    {map, mapboxgl, accessToken, base_url}) { //took out old props from here
    const [value, setValue] = useState("");
    let [parcel, setParcel] = useState(null);
    const [census, setCensus] = useState(null);
    const [display, setDisplay] = useState(census != null); //sidebar
    const [domainDisplay, setDomainDisplay] = useState(false);
    const [requestLoading, setRequestLoading] = useState(false);

    //get the value that is searched in the search bar
    const onRetrieveCallback = useCallback(async (x) => {
        let response_data = await get_point_data(x.features[0].geometry.coordinates, true, false);
        setValue(x.features[0].properties.name);
        if(!response_data.in_domain){
            setDisplay(false);
            setDomainDisplay(true);
        }
        else {
            if(response_data.parcel_analysis != null) {
                setDomainDisplay(false);
                setDisplay(true);
            }
            else{
                setDomainDisplay(true);
                setDisplay(false);
            }
        }
    }, [setValue]);

    const closeSideBar = useCallback(() => {
        setDisplay(false);
        setValue("");
    }, [setDisplay]);


    const closeOutsideDomain = useCallback(() => {
        setDomainDisplay(false);
    }, [setDisplay]);


    async function get_point_data(loc, parcel, census) {
        setRequestLoading(true);
        try {
              const response = await instance.post(base_url+ "/get_point_data", {
                            'domain_name': "Los Angeles",
                            'lat': loc[1],
                            'lng': loc[0]
                          });
              if (parcel && census) {
                    setParcel(response.data.parcel_analysis);
                    setCensus(response.data.block_analysis);
              }
              if (parcel && !census){
                  setParcel(response.data.parcel_analysis)
                  setCensus(null)
              }
              if (!parcel && census){
                  setParcel(null)
                  setCensus(response.data.block_analysis)
              }
              return(response.data);
          } catch (error) {
            console.error('Error sending POST request:', error);
          } finally {
              setRequestLoading(false);
          }
    };


    async function on_map_click(e) {
            //from : https://docs.mapbox.com/mapbox-gl-js/example/queryrenderedfeatures-around-point/
            // Find features intersecting the point.

            if (requestLoading) {
                console.log("click blocked");
                return
            }
            const selectedFeatures = map.queryRenderedFeatures(e.point, {
                layers: ['census-tracts']
            });

            // if the click intersects a feature, add the highlighted layer that matches FLD_AR_ID
            if (selectedFeatures.length > 0) {
                // can see properties of clicked features in the log
                console.log("in onclick");
                const features = selectedFeatures[0].properties
                console.log(features)
                const id = features.id
                map.setFilter("census-tracts-highlighted", ['==', 'id', id]);
                let response_data = await get_point_data(Object.values(e.lngLat), false, true);
                map.flyTo({
                    center: e.lngLat,
                    essential: true,
                    zoom: 13
                });
                setValue("Census Tract Report")
                if(!response_data.in_domain){
                    setDisplay(false);
                    setDomainDisplay(true);
                }
                else {
                    setDomainDisplay(false);
                    setDisplay(true);
                }
            } else {
                map.setFilter('census-tracts-highlighted', false); //makes it so nothing is selected
                setDisplay(false);
                setCensus(null);
            }
        }

    useEffect(()=>{
        map.on('click', on_map_click)
    }, [])

    return (
        <div className='sidebar' data-testid="searchbar-test">
            <div className='searchbar'>
                {domainDisplay && <OutsideDomain closeSideBar={closeOutsideDomain}></OutsideDomain>}
                { (display && (census || parcel)) && <SideBar census={census} parcel={parcel} searchResult={value} closeSideBar={closeSideBar} driver="river" ></SideBar> }
                <SearchBox onRetrieve={onRetrieveCallback} map={map} mapboxgl={mapboxgl} marker={true}
                           accessToken={accessToken} value={""}
                           placeholder='Enter an Address or Click to View Census Tract Flood Report'>
                </SearchBox>
            </div>
        </div>
)
}